<template>
    <div class="export-step">
        <template v-for="(step, index) of steps">
            <span class="line"  :class="{active: currentStep >= index}" v-if="index > 0" :key="index"></span>
            <span class="step-item" :class="{active: currentStep >= index}" :key="index">
                {{step.label}}
            </span>
        </template>
    </div>
</template>
<script>
export default {
    name: 'export-staps',
    props: {
        steps: Array,
        currentStep: Number
    }
}
</script>
<style lang="scss">
.export-step{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .step-item{
        line-height: 40px;
        font-size: 14px;
        color: #ffffff;
        flex: 0 0 auto;
        &.active{
            color: #0ed3ff;
        }
    }
    .line{
        width: 106px;
        height: 0;
        border-bottom: 2px dashed #696969;
        margin: 0 8px;
        flex: 1 1 auto;
        &.active{
            border-bottom: 2px dashed #0ed3ff;
        }
    }
}
</style>
